// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"message-view-m__wrapper__2hXuT","success":"message-view-m__success__iW2SL","error":"message-view-m__error__YsJT1"};